import { render, staticRenderFns } from "./InwardStock.vue?vue&type=template&id=7b128912&scoped=true&"
import script from "./InwardStock.vue?vue&type=script&lang=js&"
export * from "./InwardStock.vue?vue&type=script&lang=js&"
import style0 from "./InwardStock.vue?vue&type=style&index=0&id=7b128912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b128912",
  null
  
)

export default component.exports